const fetchSeatData = async (date, subtripId, tenant_subdomain) => {
   let url = '';
   try {
      let apiDomain = process.env.REACT_APP_API_MODULE_DOMAIN;
      
      // Ensure we use the correct protocol (http vs https)
      if (typeof window !== 'undefined') {
         const currentProtocol = window.location.protocol; // 'http:' or 'https:'
         apiDomain = apiDomain.replace(/^https?:/, currentProtocol);
      }

      url = `${apiDomain}/tickets/seat/${encodeURIComponent(subtripId)}/${encodeURIComponent(date)}`;
      if (tenant_subdomain) {
         url += `?tenant_subdomain=${encodeURIComponent(tenant_subdomain)}`;
      }
      const response = await fetch(url);

      const result = await response.json();
      return result;
   } catch (error) {
      console.error('Fetch Seat Data Error:', error);
      return { 
         status: 'failed', 
         message: `Network error or invalid response: ${error.message} (URL: ${url})` 
      };
   }
};

export default fetchSeatData;
